export interface BrandCategoryItem {
  name: string;
  url: string;
  imageUrl: string;
  imageAlt: string;
}

export interface BrandCategoryDefinition {
  type: string;
  brandNames: BrandCategoryItem[];
}

export const BRAND_CATEGORY_DEFINITIONS: BrandCategoryDefinition[] = [
  {
    type: 'Best for Acne & Blemish-Prone Skin',
    brandNames: [
      {
        name: 'cosrx',
        url: '/brand/cosrx/',
        imageUrl: 'https://media.skin-seoul.com/brand-category-images/COSRX.png',
        imageAlt: 'cosrx',
      },
      {
        name: 'SOME BY MI',
        url: '/brand/some-by-mi/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/26.png',
        imageAlt: 'SOME BY MI',
      },
      {
        name: 'SKIN1004',
        url: '/brand/skin1004/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/skin1004.png',
        imageAlt: 'SKIN1004',
      },
      {
        name: 'BENTON',
        url: '/brand/benton/',
        imageUrl: 'https://media.skin-seoul.com/brand-category-images/Benton.png',
        imageAlt: 'BENTON',
      },
      {
        name: 'MustaeV',
        url: '/brand/mustaev/',
        imageUrl: 'https://media.skin-seoul.com/brand-category-images/mustaev.webp',
        imageAlt: 'MustaeV',
      },
      {
        name: 'medicube',
        url: '/brand/medicube/',
        imageUrl: 'https://media.skin-seoul.com/brand-category-images/Medicube.png',
        imageAlt: 'medicube',
      },
    ],
  },
  {
    type: 'Best for Sensitive Skin',
    brandNames: [
      {
        name: 'AESTURA',
        url: '/brand/aestura/',
        imageUrl: 'https://media.skin-seoul.com/brand-category-images/aestura.png',
        imageAlt: 'AESTURA',
      },
      {
        name: 'ROUND LAB',
        url: '/brand/round-lab/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/22.png',
        imageAlt: 'ROUND LAB',
      },
      {
        name: 'Abib',
        url: '/brand/abib/',
        imageUrl: 'https://media.skin-seoul.com/brand-category-images/Abib.png',
        imageAlt: 'Abib',
      },
      {
        name: 'Dr. AG',
        url: '/brand/dr-ag/',
        imageUrl: 'https://skin-seoul-assets.s3.us-west-2.amazonaws.com/brands/dr-ag.webp',
        imageAlt: 'Dr. AG',
      },
      {
        name: 'Anua',
        url: '/brand/anua/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/1.png',
        imageAlt: 'Anua',
      },
      {
        name: 'COSRX',
        url: '/brand/cosrx/',
        imageUrl: 'https://media.skin-seoul.com/brand-category-images/COSRX.png',
        imageAlt: 'cosrx',
      },
    ],
  },
  {
    type: 'Best for Dry Skin',
    brandNames: [
      {
        name: 'LANEIGE',
        url: '/brand/laneige/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/17.png',
        imageAlt: 'LANEIGE',
      },
      {
        name: 'Dr. Jart+',
        url: '/brand/dr-jart/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/6.png',
        imageAlt: 'Dr. Jart+',
      },
      {
        name: 'ILLIYOON',
        url: '/brand/illiyoon/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/12.png',
        imageAlt: 'ILLIYOON',
      },
      {
        name: 'Pyunkang Yul',
        url: '/brand/pyunkang-yul/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/21.png',
        imageAlt: 'Pyunkang Yul',
      },
      {
        name: 'belif',
        url: '/brand/belif/',
        imageUrl: 'https://media.skin-seoul.com/brand-category-images/Belif.png',
        imageAlt: 'belif',
      },
      {
        name: 'SKINFOOD',
        url: '/brand/skinfood/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/25.png',
        imageAlt: 'SKINFOOD',
      },
    ],
  },
  {
    type: 'Best for Anti-Aging, Firming and Brightening',
    brandNames: [
      {
        name: 'MISSHA',
        url: '/brand/missha/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/20.png',
        imageAlt: 'MISSHA',
      },
      {
        name: 'Beauty of Joseon',
        url: '/brand/beauty-of-joseon/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/3.png',
        imageAlt: 'Beauty of Joseon',
      },
      {
        name: 'ma:nyo',
        url: '/brand/manyo/',
        imageUrl: 'https://media.skin-seoul.com/brand-category-images/manyo.png',
        imageAlt: 'ma:nyo',
      },
      {
        name: 'Sulwhasoo',
        url: '/brand/sulwhasoo/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/27.png',
        imageAlt: 'Sulwhasoo',
      },
      {
        name: 'CKD',
        url: '/brand/ckd/',
        imageUrl: 'https://media.skin-seoul.com/brand-category-images/CKD.png',
        imageAlt: 'CKD',
      },
      {
        name: 'AHC',
        url: '/brand/ahc/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/2.png',
        imageAlt: 'AHC',
      },
    ],
  },
  {
    type: 'Best Sunscreen & UV Protection',
    brandNames: [
      {
        name: 'ROUND LAB',
        url: '/brand/round-lab/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/22.png',
        imageAlt: 'ROUND LAB',
      },
      {
        name: 'Isntree',
        url: '/brand/isntree/',
        imageUrl: 'https://media.skin-seoul.com/brand-category-images/Isntree.png',
        imageAlt: 'Isntree',
      },
      {
        name: 'INNISFREE',
        url: '/brand/innisfree/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/13.png',
        imageAlt: 'INNISFREE',
      },
      {
        name: 'TONYMOLY',
        url: '/brand/tonymoly/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/28.png',
        imageAlt: 'TONYMOLY',
      },
      {
        name: 'Holika Holika',
        url: '/brand/holika-holika/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/11.png',
        imageAlt: 'Holika Holika',
      },
      {
        name: "d'Alba",
        url: '/brand/dalba/',
        imageUrl: 'https://media.skin-seoul.com/brand-category-images/d_Alba.png',
        imageAlt: "d'Alba",
      },
    ],
  },
  {
    type: 'Best for Cruelty-Free',
    brandNames: [
      {
        name: 'Isntree',
        url: '/brand/isntree/',
        imageUrl: 'https://media.skin-seoul.com/brand-category-images/Isntree.png',
        imageAlt: 'Isntree',
      },
      {
        name: 'Dear Klairs',
        url: '/brand/dear-klairs/',
        imageUrl: 'https://media.skin-seoul.com/brand-category-images/DearKlairs.png',
        imageAlt: 'Dear Klairs',
      },
      {
        name: "I'm from",
        url: '/brand/im-from/',
        imageUrl: 'https://media.skin-seoul.com/brand-category-images/ImFrom.png',
        imageAlt: "I'm From",
      },
      {
        name: 'PURITO Seoul',
        url: '/brand/purito-seoul/',
        imageUrl: 'https://media.skin-seoul.com/brand-category-images/Purito.png',
        imageAlt: 'Purito',
      },
      {
        name: 'BENTON',
        url: '/brand/benton/',
        imageUrl: 'https://media.skin-seoul.com/brand-category-images/Benton.png',
        imageAlt: 'BENTON',
      },
      {
        name: 'ILLIYOON',
        url: '/brand/illiyoon/',
        imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/12.png',
        imageAlt: 'ILLIYOON',
      },
    ],
  },
];
